import React, { useState, useEffect } from 'react';
import './Differentiators.css';

const features = [
  {
    title: 'Learn from POV Videos',
    desc: 'In a world where intelligent agents can help you with every part of life, what better way to share context with those agents than the view of the world the way you see it.',
    color: '#fef08a'
  },
  {
    title: 'Long context, short feedback',
    desc: 'You can record hours of video, and give it to us to analyze. We understand deep patterns in those, and surface them as statistically useful insights with our novel output harnesses and user experiences.',
    color: '#bbf7d0'
  },
  {
    title: 'Telemetry for precision',
    desc: 'We have more than just visuals, our input harnesses allow our intelligent models obtains everything from depth maps, to precise position, angle, and time measurement in videos, to accelerometer and gyroscope data - helping us model the environment a lot more precisely.',
    color: '#bfdbfe'
  },
  {
    title: 'Foundational model research',
    desc: 'We train and finetune special purpose models for reasoning over our specific use-cases that we are building for. These models are built to reason over our special video annotations and sensor data.',
    color: '#fecaca'
  }
];

export default function Differentiators() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [hoverIndex, setHoverIndex] = useState(null);

  useEffect(() => {
    // Only cycle if not hovering over a specific item
    if (hoverIndex !== null) return;

    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % features.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [hoverIndex]);

  const displayIndex = hoverIndex !== null ? hoverIndex : activeIndex;
  const activeFeature = features[displayIndex];

  return (
    <section className="diff-section" id="vision">
      <div className="diff__header">
        <h2 className="diff__heading">Our Vision</h2>
        <p className="diff__subheading">Explore our core research and capabilities.</p>
      </div>
      
      <div className="diff__container">
        
        <div className="diff__tabs">
          {features.map((feature, index) => {
            const isActive = index === displayIndex;
            return (
              <div 
                key={index}
                className={`diff__tab ${isActive ? 'diff__tab--active' : ''}`}
                onMouseEnter={() => setHoverIndex(index)}
                onMouseLeave={() => setHoverIndex(null)}
                style={{
                  backgroundColor: isActive ? feature.color : 'transparent'
                }}
              >
                <div className="diff__tab-title">{feature.title}</div>
              </div>
            );
          })}
        </div>

        <div className="diff__content-display" style={{ borderLeftColor: activeFeature.color }}>
          <div className="diff__content-inner">
            <h3 style={{ borderBottomColor: activeFeature.color }}>
              {activeFeature.title}
            </h3>
            <p>{activeFeature.desc}</p>
          </div>
        </div>

      </div>
    </section>
  );
}
